import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import Preloader from '../../components/Preloader';
import Banner from '../../components/Banner';
import Listing from './Listing';

import { capitalizeWords } from '../../utils/Helper';

/**
 * Categories Component
 * Renders a listing page for a given category based on the URL slug.
 */
const Categories = () => {
	const { slug } = useParams();

	// Memoize title to avoid recalculations on re-renders
	const title = useMemo(() => capitalizeWords(slug.replace(/-/g, ' ')), [slug]);

	useEffect(() => {
		document.body.classList.add('inner-page', 'blog');
		return () => {
			document.body.classList.remove('inner-page', 'blog');
		};
	}, []);

	return (
		<>
		<Preloader />
		<Banner page={{ title: `Category: ${title}` }} />
		<Listing type="category" />
		</>
	);
};

export default Categories;
